import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
	Container,
	Row,
	Col,
	Button,
	ButtonToolbar,
	ButtonGroup,
	Card,
	CardBody,
	CardTitle,
	CardSubtitle,
	CardText,
	CardFooter,
} from "reactstrap";
import { getCOVIDQuestions } from "../../api";
import { useAuth } from "contexts/auth-context";
function QA(props) {
	const { index, _id, question, answer } = props;

	const { user } = useAuth();
	const isAuthenticated = Boolean(user);
	return (
		<div style={{ marginTop: 8 }}>
			<Card>
				<CardBody style={{ paddingBottom: 5 }}>
					<h2>Question:</h2>
					<CardText>{question.question}</CardText>
					<p>
						{" "}
						<span className="text-muted">
							- {question.name} at {new Date(answer.timestamp).toLocaleString()}
						</span>
					</p>
				</CardBody>
				{answer && (
					<CardBody style={{ paddingTop: 5 }}>
						<h2>Answer:</h2>
						<CardText>{answer.answer}</CardText>
						<p>
							{" "}
							<span className="text-muted">
								- {answer.name} at {new Date(answer.timestamp).toLocaleString()}
							</span>
						</p>
					</CardBody>
				)}
				{isAuthenticated && (
					<CardFooter style={{ display: "flex", justifyContent: "flex-end" }}>
						<Button
							outline
							color="secondary"
							size="sm"
							tag={Link}
							to={{
								pathname: `/covid-19/answer/${_id}`,
							}}
						>
							Answer
						</Button>
					</CardFooter>
				)}
			</Card>
		</div>
	);
}

const defaultQuestion = {
	_id: "123345abc",
	question: {
		timestamp: new Date(),
		name: "Nick",
		email: "n@g.com",
		question: "lorem epsum",
	},
	answer: {
		timestamp: new Date(),
		name: "Nick",
		email: "n@g.com",
		answer:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque lectus elit, lacinia et vestibulum egestas, varius vitae urna. Maecenas est lorem, mollis a purus sed, mollis dignissim ipsum. Ut sit amet elit a massa hendrerit posuere vitae ut risus. Ut tincidunt lectus quis ligula luctus aliquam. Praesent tincidunt porttitor porta. Curabitur ultricies, felis quis euismod semper, lorem magna pellentesque neque, vel pellentesque nibh dui malesuada mauris. Nam non felis dignissim, pellentesque tortor euismod, dictum eros.",
	},
};

function QuestionsAndAnswers() {
	const { user } = useAuth();
	const isAuthenticated = Boolean(user);
	const [questions, setQuestions] = useState([]);
	const [status, setStatus] = useState({
		loading: true,
	});
	useEffect(() => {
		getCOVIDQuestions()
			.then(({ success, data }) => {
				console.log(data);
				setQuestions(data);
				setStatus({ loading: false });
			})
			.catch((err) => {
				console.error(err);
				setQuestions([]);
				setStatus({ loading: false, error: err });
			});
	}, []);
	return (
		<Container>
			<h1 style={{ textAlign: "center" }}>COVID-19: Ask an Expert Q&A</h1>
			<div style={{ display: "flex" }}>
				<Button
					tag={Link}
					to="/covid-19/ask-question"
					style={{ marginLeft: "auto" }}
					size="sm"
					color="primary"
					outline
				>
					Submit A COVID-19 Question
				</Button>
			</div>
			<hr></hr>
			{status.loading && <h4 className="text-center">...Loading</h4>}
			{(status.error ||
				questions.filter((q) => isAuthenticated || q?.answer?.body).length ===
					0) && (
				<div style={{ display: "flex", flexDirection: "column" }}>
					<h4 className="text-center">No Questions Submitted... yet.</h4>
					<Button
						tag={Link}
						to="/covid-19/ask-question"
						style={{ margin: "auto", marginTop: 4 }}
						color="primary"
					>
						Submit A COVID-19 Question
					</Button>
				</div>
			)}
			{questions
				.sort(
					(a, b) =>
						new Date(a?.question?.timestamp) - new Date(b?.question?.timestamp)
				)
				.filter((q) => isAuthenticated || q?.answer?.body)
				.map((q = {}, i) => (
					<QA key={`qa:${i}`} {...q} />
				))}
		</Container>
	);
}
export default QuestionsAndAnswers;
